// extracted by mini-css-extract-plugin
module.exports = {"overflow":"SignContainer_overflow__1gV6j","box":"SignContainer_box__6LeFN"};